import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { API_DOMAIN } from './globals'; // Import the global domain name

function Matka() {

    const [singleRound, setSingleRound] = useState([]);
    const [doubleRound, setDoubleRound] = useState([]);

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getMatkaGames.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if(data.Status=="Error") {
                    sessionStorage.setItem("LogoutMsg",data.Message)
                    window.location = '/';
                } else {
                    setSingleRound(data.data[0].SingleRound);
                    setDoubleRound(data.data[1].DoubleRound);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="match-content">
                <div className="ab2-main casino">
                    
                    <div className="match-box" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Satta (Single Round)</span>
                                <span style={{ float: 'right' }}></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        {singleRound.map((row, index) => (
                            <div className="card event-name text-center my-2">
                                <Link to={`/Dashboard/MatkaBet/${row.UID}/${row.LotteryName}/${new Date(row.OpenBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}/${new Date(row.CloseBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}/${row.AutoNo}/${row.RoundName}`}>
                                    <h5 style={{ textTransform: 'uppercase' }}>{row.LotteryName}-{formatDateWithDashes(row.OpenBetTime)}</h5>
                                    <time>{new Date(row.OpenBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })} To {new Date(row.CloseBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}</time>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* <div className="match-box">
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Satta (Double Round)</span>
                                <span style={{ float: 'right' }}></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        {doubleRound.map((row, index) => (
                            <div className="card event-name text-center my-2">
                                <Link to={`/Dashboard/MatkaBetDR/${row.UID}`}>
                                    <h5 style={{ textTransform: 'uppercase' }}>{row.LotteryName}-{formatDateWithDashes(row.OpenBetTime)}</h5>
                                    <time>{new Date(row.OpenBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })} To {new Date(row.CloseBetTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}</time>
                                </Link>
                            </div>
                        ))}
                    </div> */}

                </div>
            </section>
        </>
    )
}

export default Matka;
